import { useEffect } from "react";
import { useLocation } from "react-router-dom";
/**
 * @NOTE https://reactrouter.com/web/guides/scroll-restoration
 */
export var ScrollToTop = function () {
    var pathname = useLocation().pathname;
    useEffect(function () {
        var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({
            top: 0,
            behavior: prefersReducedMotion ? "auto" : "smooth",
        });
    }, [pathname]);
    return null;
};
